import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../models/DataFunctions.js";
import addLogDocument from "./addLogDocument.js"; // Assuming a custom log function

const refreshCounters = async (token, folderid, prefix) => {
  // Define the endpoint URL
  const url = `${prefix}actions/refresh-counters/${folderid}`;

  // Define the request body

  // Define headers
  const headers = {
    "Content-Type": "application/json; charset=utf-8",
    Authorization: `Bearer ${token}`,
  };

  try {
    // Make the POST request using native fetch
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
    });

    const auth = getAuthCentral();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      return "User not logged in";
    }

    const db = getFirestore();
    const userRef = doc(db, "user", currentUser.uid);
    const userSnapshot = await getDoc(checkDB(userRef));

    if (!userSnapshot.exists()) {
      return "User document not found";
    }

    const org_id = userSnapshot.get("org_id");
    const responseText = await response.text();

    // Log the request and response details
    await addLogDocument(
      url,
      prefix,
      userRef,
      org_id,
      response.status.toString(),
      "", // Additional optional fields
      "",
      "",
      responseText
    );

    // Check if the request was successful
    if (response.ok) {
      const responseData = JSON.parse(responseText);
      return responseData;
    } else {
      console.error(`Failed to get graph data: ${response.status}`);
      return "";
    }
  } catch (error) {
    console.error(`Exception occurred: ${error.message}`);
    return "";
  }
};

export default refreshCounters;
